/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PG連携会社
 * @export
 * @interface ListGroupCompanies200ResponseCompaniesInner
 */
export interface ListGroupCompanies200ResponseCompaniesInner {
    /**
     * 所属ステータス 1: 未所属, 2: 当該PGに所属, 3: 他のPGに所属
     * @type {number}
     * @memberof ListGroupCompanies200ResponseCompaniesInner
     */
    status: ListGroupCompanies200ResponseCompaniesInnerStatusEnum;
    /**
     * グループコード
     * @type {string}
     * @memberof ListGroupCompanies200ResponseCompaniesInner
     */
    companyCode: string;
    /**
     * グループ名
     * @type {string}
     * @memberof ListGroupCompanies200ResponseCompaniesInner
     */
    groupName: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof ListGroupCompanies200ResponseCompaniesInner
     */
    companyId: string;
    /**
     * 会社名
     * @type {string}
     * @memberof ListGroupCompanies200ResponseCompaniesInner
     */
    companyName: string;
    /**
     * 会社住所
     * @type {string}
     * @memberof ListGroupCompanies200ResponseCompaniesInner
     */
    companyAddress?: string;
}


/**
 * @export
 */
export const ListGroupCompanies200ResponseCompaniesInnerStatusEnum = {
    NONE: 1,
    MEMBER: 2,
    OTHER_MEMBER: 3
} as const;
export type ListGroupCompanies200ResponseCompaniesInnerStatusEnum = typeof ListGroupCompanies200ResponseCompaniesInnerStatusEnum[keyof typeof ListGroupCompanies200ResponseCompaniesInnerStatusEnum];


/**
 * Check if a given object implements the ListGroupCompanies200ResponseCompaniesInner interface.
 */
export function instanceOfListGroupCompanies200ResponseCompaniesInner(value: object): value is ListGroupCompanies200ResponseCompaniesInner {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    return true;
}

export function ListGroupCompanies200ResponseCompaniesInnerFromJSON(json: any): ListGroupCompanies200ResponseCompaniesInner {
    return ListGroupCompanies200ResponseCompaniesInnerFromJSONTyped(json, false);
}

export function ListGroupCompanies200ResponseCompaniesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGroupCompanies200ResponseCompaniesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'companyCode': json['company_code'],
        'groupName': json['group_name'],
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'companyAddress': json['company_address'] == null ? undefined : json['company_address'],
    };
}

export function ListGroupCompanies200ResponseCompaniesInnerToJSON(json: any): ListGroupCompanies200ResponseCompaniesInner {
    return ListGroupCompanies200ResponseCompaniesInnerToJSONTyped(json, false);
}

export function ListGroupCompanies200ResponseCompaniesInnerToJSONTyped(value?: ListGroupCompanies200ResponseCompaniesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'company_code': value['companyCode'],
        'group_name': value['groupName'],
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'company_address': value['companyAddress'],
    };
}

